import keyMirror from 'keymirror-nested'

export default keyMirror({
  ZIP_CODES: {
    FETCH: {
      REQUEST: null,
      SUCCEEDED: null,
      FAILED: null,
    },
  },
})
